export default __webpack_public_path__ + "static/media/logo.40be646f.png";